import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogPosts, BlogPost } from '../../data/blogs';
import './BlogDetail.css';

const BlogDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [post, setPost] = useState<BlogPost | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id) {
      const foundPost = blogPosts.find(p => p.id === parseInt(id));
      setPost(foundPost || null);
    }
  }, [id]);

  if (!post) {
    return (
      <div className="blog-detail-page">
        <div className="blog-detail-container blog-not-found">
          <h1>Blog Post Not Found</h1>
          <p>We couldn't find the article you were looking for.</p>
          <Link to="/blogs" className="blog-detail-back">
            Return to Blogs
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-detail-page">
      <div className="blog-detail-container">
        
        <div className="blog-detail-header">
          <span className="blog-detail-category">{post.category}</span>
          <h1 className="blog-detail-title">{post.title}</h1>
          
          <div className="blog-detail-meta">
            <span className="blog-detail-author">By {post.author}</span>
            <span>•</span>
            <span>{post.date}</span>
          </div>
        </div>

        <div className="blog-detail-hero">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
        </div>

        <div 
          className="blog-detail-content"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />

        <Link to="/blogs" className="blog-detail-back">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to all blogs
        </Link>
        
      </div>
    </div>
  );
};

export default BlogDetail;
